// removed by extract-text-webpack-plugin
module.exports = {"Dialog":"Dialog--1M-2z","ButtomToolbar":"ButtomToolbar--2KFeq"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Dialogs/OneButtonDialog/OneButtonDialog.scss
// module id = 941
// module chunks = 1